import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GridRegistrationTypeEnum } from '@bo-client/activation-management/grid-registration/model/grid-registration.enum';
import { path } from '@bo-client/shared/constants/path';
import { DataShareService } from '@bo-client/shared/services/data-share.service';

@Component({
  selector: 'app-portal-configuration-page',
  templateUrl: './portal-configuration-page.component.html',
  styleUrls: ['./portal-configuration-page.component.scss']
})
export class PortalConfigurationPageComponent implements OnInit {
  public routes: any[];

  // returns the absolute path to the page based on the current hostname / npath where the application runs
  public gridRegistrationExternalUrl(grid: GridRegistrationTypeEnum) {
    // first we get the path to the current application to the "#"

    return this.basePath + 'external/' + path.cmGridRegistration + '/' + grid + path.create;
  }

  get commissioningExternalUrl() {
    return this.basePath + 'external/' + path.cmCommissioningManagement;
  }

  get connectionChangeExternalUrl() {
    return this.basePath + 'external/' + path.orderRequestWizard;
  }

  get basePath() {
    return window.location.href.split('#')[0] + '#/';
  }
  constructor(private router: Router, public dataShareService: DataShareService) {}

  ngOnInit() {
    this.routes = this.router.config;
  }

  copyLink(path: string) {
    const url = `${path}`;
    navigator.clipboard.writeText(url).then(() => {
      alert('Link in die Zwischenablage kopiert!');
    });
  }

  protected readonly GridRegistrationTypeEnum = GridRegistrationTypeEnum;
}
